<template>
  <v-container>
    <v-toolbar flat color="white">
      <v-toolbar-title class="mr-2">{{ reseller ? $store.state.auth.user.reseller.name : '' }}</v-toolbar-title>
      <v-divider vertical></v-divider>
      <v-toolbar-title class="ml-2">{{ $t('Entities') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        data-cy="button-new-entity"
        color="primary"
        dark
        @click.stop="dialog = true"
      >{{ $t('New entity') }}</v-btn>
    </v-toolbar>
    <v-row>
      <v-col cols="12" sm="6" lg="4" xl="3" v-for="(item, index) in entities" :key="index">
        <v-card>
          <v-row justify="space-between" class="px-2">
            <v-col cols="auto" class="headline">{{item.name}}</v-col>
            <v-col cols="auto">
              <v-icon data-cy="icon-edited-entity" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon data-cy="icon-deleted-entity" @click="deleteItem(item)">mdi-delete</v-icon>
            </v-col>
          </v-row>
          <v-card-text>
            <v-text-field :label="$t('ID')" readonly :value="item.entity_app_id"></v-text-field>
            <v-text-field v-if="item.siret" label="Siret" readonly :value="item.siret"></v-text-field>
            <v-text-field v-if="item.vat" :label="$t('VAT number')" readonly :value="item.vat"></v-text-field>
            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('Address') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{item.street1}}
                  <div v-if="item.street2">
                    <br />
                    {{item.street2}}
                  </div>
                  <div v-if="item.street3">
                    <br />
                    {{item.street3}}
                  </div>
                  <br />
                  {{item.postal_code}} {{item.city}}
                  <br />
                  {{item.country | getCountryName($i18n.locale)}}
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header>{{ $t('Billing address') }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{item.billing_street1}}
                  <div v-if="item.billing_street2">
                    <br />
                    {{item.billing_street2}}
                  </div>
                  <div v-if="item.billing_street3">
                    <br />
                    {{item.billing_street3}}
                  </div>
                  <br />
                  {{item.billing_postal_code}} {{item.billing_city}}
                  <br />
                  {{item.billing_country | getCountryName($i18n.locale)}}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <emails-entity-select :entity="item"></emails-entity-select>
            <billing-information-expansion-panel :entity="item"></billing-information-expansion-panel>
            <v-row justify="space-between">
              <v-col cols="auto"></v-col>
              <v-col cols="auto" class="text-center">
                <v-icon large>mdi-account-circle</v-icon>
                <br />
                {{ item.users_count }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <add-edit-entity-dialog v-model="dialog" @close="close"></add-edit-entity-dialog>
  </v-container>
</template>

<script>
import countries from "i18n-iso-countries";
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import AddEditEntityDialog from "../../components/AddEditEntityDialog";
import EmailsEntitySelect from "../../components/EmailsEntitySelect";
import BillingInformationExpansionPanel from '../../components/BillingInformationExpansionPanel.vue';

export default {
  name: "ResellersEntities",
  components: { AddEditEntityDialog, EmailsEntitySelect, BillingInformationExpansionPanel},
  mixins: [snackbar],
  data() {
    return {
      loading: false,
      dialog: false,
      headers: [
        {
          text: this.$t("Name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("Address"),
          align: "start",
          sortable: false,
          value: "adress",
        },
        {
          text: this.$t("Users"),
          align: "center",
          sortable: false,
          value: "users",
        },
        {
          text: this.$t("Actions"),
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      reseller: (state) => state.auth.user.reseller.id,
      entities: (state) => state.entities.items,
    }),
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    if (!this.reseller) {
      this.$router.push({ name: "Home" });
    }
    if (this.entities.length === 0) {
      this.loading = true;
      this.$store
        .dispatch("entities/fetchAll")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
    }
  },
  methods: {
    showUsers(item) {
      this.$store.state.entities.selectedItem = item;
      this.$router.push({
        name: "Users",
      });
    },
    editItem(item) {
      this.$store.commit("entities/setEditedId", item.id);
      this.$store.commit("entities/setEditedItem", Object.assign({}, item));
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("Are you sure you want to delete this item ?"))) {
        this.$store
          .dispatch("entities/deleteItem", item.id)
          .then(() =>
            this.snackbar("success", this.$t("snackbar-message-entity.deleted"))
          )
          .catch((error) => {
            let text = error.message;

            if (
              error.response.status === 422 &&
              error.response.data?.errors?.reseller_entity &&
              error.response.data.errors.reseller_entity.length > 0
            ) {
              text = error.response.data.errors.reseller_entity[0];
            }
            this.snackbar("red", text);
          });
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.$store.dispatch("entities/resetEditedItem");
      }, 300);
    },
  },
  filters: {
    getCountryName(value, locale) {
      return countries.getName(value, locale);
    },
  },
};
</script>